/**
 * The public share view: one person's games, read-only, no sign-in.
 *
 * Deliberately NOT `authedFetch`. The token in the URL is the only credential,
 * and the server verifies its signature and age before returning anything; a
 * forged, expired or malformed token gets a 404 with no data (fail closed).
 * The content-type check matters as much as the status: if the Hosting rewrite
 * for /api/** were ever missing, the SPA fallback would answer 200 with
 * index.html, and this must read that as broken, not as an empty list.
 */
import type { EventRow, Person } from "./eventsPage";

export interface ShareDto {
  person_name: string;
  events: EventRow[];
  /** Everyone on the chips, minus anyone marked hidden on share links. */
  people: Person[];
  logos: Record<string, string>;
  venue_images: Record<string, string>;
}

export async function fetchShared(token: string): Promise<ShareDto | "expired"> {
  const res = await fetch(`/api/share/${encodeURIComponent(token)}`);
  if (res.status === 404) return "expired";
  const type = res.headers.get("content-type") ?? "";
  if (!res.ok || !type.includes("application/json")) {
    throw new Error(`Could not load the shared games (HTTP ${res.status})`);
  }
  return (await res.json()) as ShareDto;
}
